// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__26wmA","messages":"Chat_messages__1s-Yh","dateDivider":"Chat_dateDivider__iEk9R"};